import Sanitize, { SimpleSanitize} from "core/Utils/SanitizeString";
import flowIdManagment from "./FlowIdManagment";
import { ErrorModuleHandler } from "core/api/handler/ErrorModuleHandler";
export default function Analytics() {
  const DEFAULT_PROPS = {
    event: "event",
    eventCategory: "minha-claro:meu-perfil",
  };
  function init() {
    window.dataLayer = window.dataLayer || [];
  }
  
  function setEvent(props = {}) {
    const mergedProps = { ...DEFAULT_PROPS, ...props };
    const { eventLabel, eventAction } = mergedProps; 
    const sanitizedEventLabel = Sanitize(eventLabel);
    const sanitizedEventAction= Sanitize(eventAction);
    
    if(!eventAction){
      throw new Error('Parâmetro eventAction é obrigatório!');
    }
    if(!eventLabel){
      throw new Error('Parâmetro EventLabel é obrigatório!');
    }
    const result = {
      ...mergedProps,
      eventAction: sanitizedEventAction,
      eventLabel: sanitizedEventLabel
    }
    window.dataLayer.push(result);
  }

  function setSuccesEvent({ eventLabel = "tentativa:sucesso", ...props }) {
    setEvent({
      ...props,
      eventLabel,
    });
  }
  function setErrorEvent({eventLabel = 'erro-nao-mapeado', ...props}) {
    const flowId = flowIdManagment().getFlowId();
    const { code } = props;
    const errorModule = ErrorModuleHandler(code);
     eventLabel = `${errorModule}|${code}|${flowId}`;

    setEvent({
      ...props,
      eventLabel,
    });
  }
  function setInputEvent(inputName="", currentFlow="", event){

    if(!inputName){
      throw new Error('Parâmetro inputName é obrigatório!');
    }
    setEvent({
      'eventAction': `preencheu:${inputName}`,
      'eventLabel': `etapa:${currentFlow}`
    })
  }
  function setVirtualPageView(url= ""){
    window.dataLayer = window.dataLayer || [];
    let page = url || window.location.pathname
    const sanitizedPage = SimpleSanitize(page);
  
    const event = {
      event: "virtual-pageview",
      page: sanitizedPage ,
    };
    // console.table(event)

    window.dataLayer.push(event);
  };
  init();
  return {
    setEvent,
    setSuccesEvent,
    setErrorEvent,
    setInputEvent,
    setVirtualPageView
  };
};
